// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e58d1e2c","94":"1ea7d12e","389":"7fceed1d","692":"98d95e44","895":"e6687125"}[chunkId] + ".chunk.js";
};